import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=33144d13&"
import script from "./Devices.vue?vue&type=script&lang=js&"
export * from "./Devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33144d13')) {
      api.createRecord('33144d13', component.options)
    } else {
      api.reload('33144d13', component.options)
    }
    module.hot.accept("./Devices.vue?vue&type=template&id=33144d13&", function () {
      api.rerender('33144d13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Devices.vue"
export default component.exports